<template>
    <div>
        <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
                    :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Data Pegawai</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0);"
                                                @click="$router.push('/')">Beranda</a></li>
                                        <li class="breadcrumb-item active" aria-current="page">Data Pegawai</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa"
                        class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <section class="team__area-two">
                <div class="container">
                    <div class="row justify-content-center gutter-24">
                        <div class="col-lg-3 col-md-6 col-sm-8" v-for="(data) in list_data" :key="data.id">
                            <div class="team__item-two shine-animate-item">
                                <div class="team__thumb-two shine-animate">
                                    <div v-if="data.file == null || data.file == undefined || data.file == ''">
                                        <img src="assets/img/noImage.png" style="height: 400px;">
                                    </div>
                                    <div v-else>
                                        <img :src="file_path + data.file" alt="" style="height: 400px;" />
                                    </div>
                                </div>
                                <div class="team__content-two">
                                    <h4 class="title"><a href="javascript:void(0)">{{ data.gelar_depan }} {{ data.nama }} {{ data.gelar_belakang }}</a></h4>
                                    <span>{{ data.jabatan }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination-wrap mt-40 mb-5">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination list-wrap">
                                <!-- Prev -->
                                <li class="page-item" :class="{ disabled: page_first === 1 }">
                                    <a class="page-link" href="javascript:void(0);" @click="btn_prev"><i
                                            class="fas fa-angle-double-left"></i></a>
                                </li>

                                <!-- Loop halaman -->
                                <li v-for="page in pagesToShow" :key="'page_' + page" class="page-item"
                                    :class="{ active: page === page_first, disabled: page === '...' }">
                                    <a v-if="page !== '...'" class="page-link" href="javascript:void(0);"
                                        @click="goToPage(page)">
                                        {{ page }}
                                    </a>
                                    <span v-else class="page-link">...</span>
                                </li>

                                <!-- Next -->
                                <li class="page-item" :class="{ disabled: page_first === page_last }">
                                    <a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>

export default {

    data() {
        return {
            data_load: false,
            form: {
                id: '',
                nama: '',
                jabatan: '',
                isi: "",
                judul: '',
                sumber: '',
                deskripsi: '',
                uraian: '',
                foto: '',
                unit_kerja: '',
                status: '',
                keterangan: '',
            },
            id: '',
            file_path: this.$store.state.url.URL_APP_SIMPEG + "uploads/",

            list_data: [],
            page_first: 1,
            page_last: 0,
            max_visible: 5,
            cari_value: "",
        }
    },
    methods: {
        getView: function () {
            fetch(this.$store.state.url.URL_DATA_PEGAWAI + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    // console.log(res_data);
                });
        },

        selectData: function (data) {
            this.form = {
                id: data.id,
                nama: data.nama,
                jabatan: data.jabatan,
                isi: data.isi,
                foto: data.foto,
            };
        },

        mdl_exit: function () {
            this.judul = "";
            this.uraian = "";
            this.file = "";
            this.file_old = "";
        },

        btn_prev: function () {
            if (this.page_first > 1) {
                this.page_first--
            } else {
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next: function () {

            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last
            } else {
                this.page_first++;
            }
            this.getView();
        },

        goToPage(page) {
            if (page === '...') return;
            this.page_first = page;
            this.getView();
        },

    },
    // =============================================================== METHODS =========================================================================

    computed: {
        pagesToShow() {
            const pages = [];
            const total = this.page_last;
            const current = this.page_first;
            const max = this.max_visible;

            if (total <= max) {
                for (let i = 1; i <= total; i++) pages.push(i);
            } else {
                pages.push(1);

                if (current > 3) pages.push("...");

                const start = Math.max(2, current - 1);
                const end = Math.min(total - 1, current + 1);

                for (let i = start; i <= end; i++) pages.push(i);

                if (current < total - 2) pages.push("...");

                pages.push(total);
            }

            return pages;
        },
    },


    mounted() {
        this.getView();
    }
};
</script>